import { ValidationErrors } from "@angular/forms"
import { catchError, map, of, pipe } from "rxjs"
import { LobbyErrorCode } from "src/app/infrastructure/lobby-proxy/enums/lobby-error-code.enum"

export interface LeadDryrunError extends ValidationErrors {
    errorCode: LobbyErrorCode
    message: string
}

export const dryrunErrors = pipe(
    map((_) => _),
    catchError(err => {
        return of(
            err.error.status?.errors?.length ?
                err.error.status?.errors?.map((e: any) => {
                    return {
                        errorCode: LobbyErrorCode[(e.code ?? 'Unknown') as keyof typeof LobbyErrorCode],
                        message: e.message ?? ''
                    } as LeadDryrunError
                })
                :
                null
        )
    }
    )
)

